import script from "./VideoSubtitleControl.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSubtitleControl.vue?vue&type=script&setup=true&lang=js"

import "./VideoSubtitleControl.vue?vue&type=style&index=0&id=0e0962a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0962a3"]])

export default __exports__